import { render, staticRenderFns } from "./CardBrandsMark.vue?vue&type=template&id=0b5363d9&scoped=true&"
import script from "./CardBrandsMark.vue?vue&type=script&lang=js&"
export * from "./CardBrandsMark.vue?vue&type=script&lang=js&"
import style0 from "./CardBrandsMark.vue?vue&type=style&index=0&id=0b5363d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5363d9",
  null
  
)

export default component.exports